import {DojoDeshi} from '../DojoDeshi.js';
import {DojoTemplates} from '../DojoTemplates.js';

import {StudentAttendanceModel} from './StudentAttendanceModel.js';
import {StudentAttendancePresentModel} from './StudentAttendancePresentModel.js';
import {StudentAttendanceCard} from './StudentAttendanceCard.js';

export class StudentAttendanceTable extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = DojoTemplates('classrecord_student_attendance/StudentAttendanceTable');

		this.attachShadow({mode:`open`});
		this.shadowRoot.appendChild(this.el);

		//`parent, classRecordId) {
		this._presentModel = new StudentAttendancePresentModel();
		this._presentModel.Listeners.add(this.sendTabHeaderSet.bind(this));
	}
	connectedCallback() {
		// console.log(`data-record=id = `,this.getAttribute(`data-record-id`));
		this.classRecordId = parseInt(this.getAttribute(`data-record-id`));
		Promise.all(
			[
			DojoDeshi.instance().RPC().AttendanceTypesWithAbsence(),
			DojoDeshi.instance().RPC().StudentsForClassRecord(this.classRecordId)
			]
		).then (
			(res)=> {
				let ats = res[0][0];
				let sams = res[1][0];
				// console.log(`ats = `, ats);
				// console.log(`sams = `, sams);
				for (let s of sams) {
					let m = new StudentAttendanceModel(s.Student, s.AttendanceType);
					this._presentModel.addStudentAttendanceModel(m);
					new StudentAttendanceCard(this.$.table, this.classRecordId, m, ats);
				}
				this.sendTabHeaderSet();
			}
		).catch(
			(err)=>{
				console.error(err);
			}
		);
	}
	sendTabHeaderSet() {
		let evt = new CustomEvent(`dojo-tab-title-set`,{
			bubbles: true,
			composed: true,
			cancelable: true,
			detail: {
				tab: `students`,
				title: `Students (${this._presentModel.count()})`,
			}
		});
		this.dispatchEvent(evt);
	}
	presentModel() {
		return this._presentModel;
	}
}

customElements.define(`dojo-student-attendance-table`, StudentAttendanceTable);